import React from "react";
import {MainBanner} from "./component/MainBanner";
import {Container} from "@chakra-ui/react";
import {VersionPicker} from "./component/VersionPicker";
import {Footer} from "./component/Footer";

const DEV_MODE = false;
const CARD_BASE_URL = DEV_MODE ? "https://www.hungfooktong.com/newweb/hft_webdev/bbcarddev" : "https://www.hungfooktong.com/bbcard";

export const App = React.memo(() => {
    const [versionPickerVisible, setVersionPickerVisible] = React.useState<"retail" | "BPD" | false>(false);

    if (versionPickerVisible === "retail") {
        return <VersionPicker forClient="門市訂購客戶" normalURL={`${CARD_BASE_URL}/orderform.php?gold=0`} goldURL={`${CARD_BASE_URL}/orderform.php?gold=1`} />;
    } else if (versionPickerVisible === "BPD") {
        return <VersionPicker forClient="企業客戶" normalURL={`${CARD_BASE_URL}/bbcard_orderform_paypal.php?gold=0`} goldURL={`${CARD_BASE_URL}/bbcard_orderform_paypal.php?gold=1`} />;
    }

    return (
        <Container maxW="687px" p={0}>
            <MainBanner />
            <Footer setVersionPickerVisible={setVersionPickerVisible} />
        </Container>
    );
});
